<template>
      <div id="PhotoAlbum"> 
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark"> 精選相片 </h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">首頁</li>
              <li class="breadcrumb-item active">精選相片</li>
            </ol>
          </div>
          <!-- /.col --> 
        </div>
        <!-- /.row --> 
      </div>
      <!-- /.Container Fluid --> 
    </div>
    <!-- /.Content Header --> 
    
    <!-- Main content -->
    <div id="b-album" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-10">
            <div class="b-filter"><a href="" class="current">全部</a><a href="">重機</a><a href="">路跑</a><a href="">單車</a><a href="">鐵人</a><a href="">球類運動</a><a href="">水上運動</a><a href="">綜合運動</a><a href="">風景生活</a></div>
          </div>
          <div class="col-sm-2">
            <button type="button" class="btn btn-block btn-primary btn-sm" data-toggle="modal" data-target="#modal-featured--set"><i class="nav-icon fas fa-plus fa-sm mr-1"></i> 新增精選相片 </button>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <table id="featured-list" class="table table-bordered table-hover">
                  <thead>
                    <tr>
                      <th> 精選相片 </th>
                      <th> 所屬相簿 </th>
                      <th> 類型 </th>
                      <th> 上傳者 </th>
                      <th> 狀態 </th>
                      <th> 加入精選日期 </th>
                      <th> 操作人 </th>
                      <th> 瀏覽量 </th>
                      <th> 留言 </th>
                      <th> 收藏 </th>
                      <th> 分享 </th>
                      <th> 操作 </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="b-photo-image"><a href=""> <img src="../../assets/backImage/album/featured-photo/featured-photo-1.jpg" alt=""/><span class="b-photo-image-enlarge"><img src="../../assets/backImage/album/featured-photo/featured-photo-1.jpg" alt=""/></span> </a></td>
                      <td class="b-album-name"><a href=""> LAVA 鐵人賽新北福隆站 2017.6.25(日)_2丙14K 07:45~08:33(已完成100%) </a></td>
                      <td class="b-category"> 單車 </td>
                      <td class="b-username"><a href=""> bart </a></td>
                      <td class="b-status b-status-display"> 顯示中 </td>
                      <td class="b-date"> 2020年05月13日 </td>
                      <td class="b-operator"> Eric Chong </td>
                      <td class="cell-xs b-view-count"> 366 </td>
                      <td class="cell-xs b-comment-count"> 0 </td>
                      <td class="cell-xs b-bookmark-count"> 0 </td>
                      <td class="cell-xs b-share-count"> 2 </td>
                      <td class="b-operate"><span type="button" class="b-operate-btn b-edit" data-toggle="modal" data-target="#modal-featured--set"> 編輯 </span><span type="button" class="b-operate-btn b-danger" data-toggle="modal" data-target="#modal-featured--remove"> 從精選移除 </span></td>
                    </tr>
                  
                  </tbody>
                  <tfoot>
                    <tr>
                      <th> 精選相片 </th>
                      <th> 所屬相簿 </th>
                      <th> 類型 </th>
                      <th> 上傳者 </th>
                      <th> 狀態 </th>
                      <th> 加入精選日期 </th>
                      <th> 操作人 </th>
                      <th> 瀏覽量 </th>
                      <th> 留言 </th>
                      <th> 收藏 </th>
                      <th> 分享 </th>
                      <th> 操作 </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <!-- /.card-body --> 
            </div>
          </div>
          <!-- /.col-12 --> 
        </div>
        <!-- /.row --> 
      </div>
      <!-- /.Container Fluid --> 
      
      <!-- Modal: 新增/編輯精選相片 -->
      <div class="modal fade" id="modal-featured--set">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">新增/編輯精選影音</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>相片編號</label>
                <p class="mb-2">輸入相片連結「P=」後的數值，e.g. https://www.soonnet.org/Photo/Photoview.aspx?A=21344&P=<span style="color:red">7471665</span></p>
                <input type="text" id="photo-link" class="form-control" placeholder="e.g. 7471665">
              </div>
              <div class="form-group">
                <label>顯示狀態</label>
                <div class="form-group">
                  <select class="form-control custom-select select2-no-search">
                    <option selected>顯示</option>
                    <option>隱藏</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
              <button type="button" class="btn btn-primary featured--set---success" data-dismiss="modal">保存</button>
            </div>
          </div>
          <!-- /.modal-content --> 
        </div>
        <!-- /.modal-dialog --> 
      </div>
      <!-- /.modal: 新增/編輯精選相片 --> 
      
      <!-- Modal: 移除精選相片 -->
      <div class="modal fade" id="modal-featured--remove">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <p>確定將相片從精選相片中移除？</p>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
              <button type="button" class="btn btn-danger featured--remove---success" data-dismiss="modal">是，移除</button>
            </div>
          </div>
          <!-- /.modal-content --> 
        </div>
        <!-- /.modal-dialog --> 
      </div>
      <!-- /.modal: 移除精選相片 --> 
    </div>
    <!-- /.Content --> 
  </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    created(){},
    methods:{
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/AdminAlbum/PhotoFeature.vue